import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FARM_ADDRESS_ONE_LINE } from '../constants/address';
import './Legal.css';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.35 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

const TermsOfService = () => (
  <motion.main className="legal-page" variants={pageVariants} initial="initial" animate="animate" exit="exit">
    <div className="container">
      <p className="legal-page__eyebrow">Legal</p>
      <h1>Terms of Service</h1>
      <p className="legal-page__updated">Last updated: April 12, 2026</p>
      <div className="legal-page__prose">
        <p>
          These Terms of Service (&quot;Terms&quot;) govern your use of the Cory Blossom website, online ordering, and related farm pickup services. By accessing the site, creating an account, or placing an order, you agree to these Terms.
        </p>

        <h2>Orders &amp; pickup</h2>
        <p>
          Product descriptions, availability, and prices are subject to change. Seasonal flowers depend on what is blooming; we may substitute comparable stems when necessary. Pickup dates and times are offered in accordance with our posted business hours and scheduling rules. You are responsible for arriving during your selected pickup window unless we notify you otherwise.
        </p>

        <h2>Payment</h2>
        <p>
          You agree to pay all charges for orders placed under your account. Payment processing may be handled by third-party providers; their terms may also apply.
        </p>

        <h2>Cancellations &amp; refunds</h2>
        <p>
          Cancellation and refund policies may vary by product type and timing. Custom or event work (including weddings) is typically quoted and contracted separately. For questions about a specific order, contact us promptly at{' '}
          <a href="mailto:coryblossom22@gmail.com">coryblossom22@gmail.com</a>.
        </p>

        <h2>Wedding &amp; event inquiries</h2>
        <p>
          Wedding and large-event florals are planned by consultation. Quotes, deposits, and scope are agreed in writing or by email as applicable. Nothing on this website constitutes a binding contract for custom event work until confirmed by Cory Blossom.
        </p>

        <h2>Intellectual property</h2>
        <p>
          All content on this site (text, images, logos, and design) is owned by Cory Blossom or its licensors and may not be copied or reused without permission.
        </p>

        <h2>Disclaimer</h2>
        <p>
          The site and services are provided &quot;as available.&quot; To the fullest extent permitted by law, we disclaim warranties not expressly stated herein. We are not liable for indirect or consequential damages arising from use of the site or products, except where prohibited by law.
        </p>

        <h2>Indemnity</h2>
        <p>
          You agree to indemnify and hold harmless Cory Blossom from claims arising from your misuse of the site, violation of these Terms, or violation of others&apos; rights.
        </p>

        <h2>Governing law</h2>
        <p>
          These Terms are governed by the laws of the State of New York, without regard to conflict-of-law rules. Disputes shall be brought in courts located in New York, unless otherwise required by law.
        </p>

        <h2>Changes</h2>
        <p>
          We may modify these Terms at any time. The &quot;Last updated&quot; date reflects the current version. Continued use of the site after changes constitutes acceptance of the revised Terms.
        </p>

        <h2>Contact</h2>
        <p>
          Cory Blossom — {FARM_ADDRESS_ONE_LINE}. Questions about these Terms? Reach us at{' '}
          <a href="mailto:coryblossom22@gmail.com">coryblossom22@gmail.com</a>
          {' '}or through our <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  </motion.main>
);

export default TermsOfService;
